import React from 'react'

import Tooltip from '@material-ui/core/Tooltip';

export default class ViewCell extends React.Component {
  constructor(props){
    super(props)

    this.state = {

    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    return (
      <Tooltip title={this.props.tooltip} placement="top" arrow>
        <a
          className="btn btn-icon btn-light-primary btn-hover-primary btn-sm min-w-auto me-1"
          data-bs-toggle="" data-bs-target=""
          onClick={e => this.props.onViewClicked()}
        >
          <span className="svg-icon svg-icon-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path opacity="0.5" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22Z" fill="currentColor"/>
              <path opacity="0.8" d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>
            </svg>
          </span>
        </a>
      </Tooltip>
    )
  }
}

ViewCell.defaultProps = {
  tooltip: 'View Details'
}
